const zhCN = {
  searchRemarkTxt: '黑名单备注',
  searchBtn: '搜索',
  listEditBtn: '编辑',
  listRemoveBtn: '移除',

  getBlacklistFail: '获取黑名单信息失败！',

  removeWarning: '您确定要删除当前黑名单人员？',
  confirmBtn: '确定',
  cancelBtn: '取消',
  removeSuccess: '删除黑名单成功！',
  removeFail: '删除黑名单失败！',

  blackImageModal: '黑名单照片',

  addListBtn: '添加黑名单',

  addModalTitle: '新增黑名单',
  editModalTitle: '修改黑名单',

  nameTxt: '姓名',
  nameBlank: '请输入黑名单人员姓名！',
  nameWarnning: '姓名最多输入20个字！',

  phoneTxt: '电话',
  phoneBlank: '请输入黑名单人员电话！',
  phoneWarnning: '请输入正确的手机号码！',

  idCardTypeTxt: '证件类型',
  idCardTypeBlank: '请输选择黑名单人员证件类型！',

  idNumberTxt: '证件号码',
  idNumberBlank: '请输入黑名单人员证件号码！',
  idNumberWarnning: '请输入正确的身份证号！',

  remarkTxt: '黑名单备注',
  remarkBlank: '请输入黑名单备注！',
  remarkWarnning: '备注最多输入40个字！',  

  imageTxt: '黑名单照片',
  imageBlank: '请上传黑名单照片！',
  uploadImageBtn: '上传黑名单照片',
  uploadImageDesc: '图片格式为jpg、jpeg、png',
  uploadSuccess: '上传成功！',
  uploadFail: '上传失败！',

  addSuccess: '添加黑名单成功！',
  addFail: '添加黑名单失败！',
  editSuccess: '修改黑名单成功！',
  editFail: '修改黑名单失败！'
}
const enUS = {
  searchRemarkTxt: 'Blacklist Remark',
  searchBtn: 'Search',
  listEditBtn: 'Edit',
  listRemoveBtn: 'Remove',

  getBlacklistFail: 'Get blacklist information failed!',

  removeWarning: 'Are you sure to delete this blacklist?',
  confirmBtn: 'Confirm',
  cancelBtn: 'Cancel',
  removeSuccess: 'Remove the blacklist successfully!',
  removeFail: 'Remove the blacklist Failed!',

  blackImageModal: 'Blacklist Photos',

  addListBtn: 'Add Blacklist',

  addModalTitle: 'Add Blacklist',
  editModalTitle: 'Edit Blacklist',
  
  nameTxt: 'Name',
  nameBlank: 'Personnel name can\'t be blank!',
  nameWarnning: 'Personnel name is up to 20 words!',

  phoneTxt: 'Phone',
  phoneBlank: 'Personnel phone can\'t be blank!',
  phoneWarnning: 'Please enter the correct phone number!',

  idCardTypeTxt: 'ID Card Type',
  idCardTypeBlank: 'ID card type can\'t be blank!',

  idNumberTxt: 'ID Number',
  idNumberBlank: 'ID number can\'t be blank!',
  idNumberWarnning: 'Please enter the correct ID number!',

  remarkTxt: 'Blacklist Remark',
  remarkBlank: 'Blacklist remark can\'t be blank',
  remarkWarnning: 'Blacklist remark  is up to 40 words!',  

  imageTxt: 'Blacklist Image',
  imageBlank: 'Please upload blacklist image',
  uploadImageBtn: 'Upload Image',
  uploadImageDesc: 'The image format is JPG, JPEG or PNG',
  uploadSuccess: 'upload successful!',
  uploadFail: 'upload failed!',

  addSuccess: 'Blacklist added successfully!',
  addFail: 'Blacklist added failed!',
  editSuccess: 'Modified blacklist successfully!',
  editFail: 'Modified blacklist failed'
}

export default { zhCN, enUS }